import "./SavedAddress.css";
import { Button, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import Success_Modal from "../common_components/common_modal/success_modal/Success_Modal";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllOrderAddress,
  getAllOrderAddressBilling,
  getSingleOrderAddress,
} from "../../features/order/orderSlice";
import React, { useEffect, useState } from "react";
import { deleteUserAddress } from "../../features/user/userSlice";
import Blue_Btn from "../common_components/common_btn/Blue_Btn/Blue_Btn";
import Gray_Btn from "../common_components/common_btn/gray_btn/Gray_Btn";

const SavedAddress = (props) => {
  const navigate = useNavigate();

  const [showSuccessModal, setShowSucsessModal] = useState(false);

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      DELETE ADDRESS
    </Tooltip>
  );

  const dispatch = useDispatch();
  const allAddress = useSelector((state) => state.order.allOrdersAddress);

  const allBillingAddress = useSelector(
    (state) => state.order.allBillingAddress,
  );

  const user = useSelector((state) => state.myaccount.addMyaccount);

  useEffect(() => {
    // if (user?.id) {
    dispatch(getAllOrderAddress());
    dispatch(getAllOrderAddressBilling());
    // }
  }, []);

  const handleDelete = async (id) => {
    const res = await dispatch(deleteUserAddress(id));
    if (res.meta?.requestStatus === "fulfilled") {
      await dispatch(getAllOrderAddress());
      await dispatch(getAllOrderAddressBilling());
    } else if (res.meta?.requestStatus === "rejected") {
    }
  };
  // if ( props?.orderAddress)
  //     props?.setOrderAddress(allAddress?.data[0]);
  // console.log(allAddress, 'allAddressallAddress');

  useEffect(() => {
    if (allAddress?.data?.length > 0) {
      props.setAddressId(allAddress.data[0].id);
    }

    if (allBillingAddress?.data?.length > 0) {
      props.setAddressBillingId(allBillingAddress.data[0].id);
    }
  }, [allAddress]);
  return (
    <section className="SavedAddress">
      <div className="container">
        <p
          className="back_text"
          onClick={() => {
            navigate("/cart");
          }}
        >
          Back
        </p>

        <div className="add_new_address_div">
          <div className="address_title_div">
            <div className="heading_div">
              <p>Saved Address</p>
            </div>
            <div className="btn_holder">
              <Gray_Btn
                // className="add_new-btn"
                btn_name=" Add New"
                onClick={() => {
                  navigate("/add-new-address");
                }}
              />
            </div>
          </div>
        </div>

        <div className="title_div">
          <p className="section_title">Shipping Address</p>
        </div>

        <div className="saved_address_main_div">
          <div className="addres_card_holder">
            <div className="row">
              {allAddress?.data?.map((address, index) => {
                const parts = [
                  address?.building,
                  address?.street,
                  address?.apartment,
                  address?.Users_Address_Detail?.Country?.name,
                  address?.Users_Address_Detail?.State?.name,
                  address?.Users_Address_Detail?.City?.name,
                  address?.Users_Address_Detail?.Pincode?.name,
                ];
                return (
                  <div
                    className="col-lg-4 col-md-6 col-sm-12 col-12"
                    key={address?.id || index}
                  >
                    <div
                      className="address_card"
                      onClick={() => {
                        props?.setOrderAddress(address);
                        props?.setAddressId(address?.id);
                      }}
                    >
                      <div className="top_address_heading">
                        <div className="heading">
                          <p>{address?.apartment}</p>
                        </div>

                        <div className="form-holder">
                          <Form.Check
                            type="radio"
                            id={address?.id}
                            checked={props?.addressId === address?.id}
                          />
                        </div>
                      </div>

                      <div className="user_address">
                        <div>
                          <p className="user_name">{address?.first_name}</p>
                        </div>

                        <div>
                          <p className="contact_no">{address?.contact_no}</p>
                        </div>

                        <div className="footer_div">
                          <div className="address_div">
                            <p>{parts.filter(Boolean).join(", ")}</p>
                          </div>
                        </div>
                      </div>

                      <div className="edit_delete_holder">
                        <div
                          className="edit_btn_div"
                          onClick={() => {
                            props?.setAddressId(address?.id);
                          }}
                        >
                          <p
                            onClick={() => {
                              navigate(`/edit-new-address/${address?.id}`);
                            }}
                          >
                            Edit
                          </p>
                        </div>

                        <div
                          className="delete_icon_holder"
                          onClick={() => {
                            handleDelete(address?.id);
                          }}
                        >
                          <OverlayTrigger
                            placement="right"
                            delay={{ show: 250, hide: 400 }}
                            overlay={renderTooltip}
                          >
                            <FontAwesomeIcon
                              icon={faTrash}
                              className="delete_icon"
                            />
                          </OverlayTrigger>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <div className="title_div">
          <p className="section_title">Billing Address</p>
        </div>

        <div className="saved_address_main_div">
          <div className="addres_card_holder">
            <div className="row">
              {allBillingAddress?.data?.map((address, index) => {
                const parts = [
                  address?.building,
                  address?.street,
                  address?.apartment,
                  address?.Users_Address_Detail?.Country?.name,
                  address?.Users_Address_Detail?.State?.name,
                  address?.Users_Address_Detail?.City?.name,
                  address?.Users_Address_Detail?.Pincode?.name,
                ];
                return (
                  <div
                    className="col-lg-4 col-md-6 col-sm-12 col-12 mb-3"
                    key={address?.id || index}
                  >
                    <div
                      className="address_card"
                      onClick={() => {
                        props?.setOrderBillingAddress(address);
                        props?.setAddressBillingId(address?.id);
                      }}
                    >
                      <div className="top_address_heading">
                        <div className="heading">
                          <p>{address?.apartment}</p>
                        </div>

                        <div className="form-holder">
                          <Form.Check
                            type="radio"
                            id={address?.id}
                            checked={props?.addressBillingId === address?.id}
                          />
                        </div>
                      </div>

                      <div className="user_address">
                        <div>
                          <p className="user_name">{address?.first_name}</p>
                        </div>

                        <div>
                          <p className="contact_no">{address?.contact_no}</p>
                        </div>

                        <div className="footer_div">
                          <div className="address_div">
                            <p>{parts.filter(Boolean).join(", ")}</p>
                          </div>
                        </div>
                      </div>

                      <div className="edit_delete_holder">
                        <div
                          className="edit_btn_div"
                          onClick={() => {
                            props?.setAddressId(address?.id);
                          }}
                        >
                          <p
                            onClick={() => {
                              navigate(`/edit-new-address/${address?.id}`);
                            }}
                          >
                            Edit
                          </p>
                        </div>

                        <div
                          className="delete_icon_holder"
                          onClick={() => {
                            handleDelete(address?.id);
                          }}
                        >
                          <OverlayTrigger
                            placement="right"
                            delay={{ show: 250, hide: 400 }}
                            overlay={renderTooltip}
                          >
                            <FontAwesomeIcon
                              icon={faTrash}
                              className="delete_icon"
                            />
                          </OverlayTrigger>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <div className="text-center address_btn_holder">
          <div className="">
            {/* <Button className="submit-btn" type="button" >
                            Proceed with Saved Address
                        </Button> */}
            {allAddress?.data?.length > 0 &&
              allBillingAddress?.data?.length > 0 && (
                <Blue_Btn
                  btnText="Proceed with Saved Address"
                  onClick={() => {
                    navigate("/checkout");
                  }}
                />
              )}
          </div>
        </div>
      </div>

      <Success_Modal
        show={showSuccessModal}
        onHide={() => {
          setShowSucsessModal(false);
        }}
        successText="Address Deleted successfully!"
      />
    </section>
  );
};

export default SavedAddress;
